import { Model } from '@/models/Model';
export class TreatmentLabel extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'TreatmentLabel';
        this.$endpoint = '/treatment-labels';
        this.$fillable = ['key', 'value'];
    }
    updateTreamentLabels(payload) {
        return this.request('put', this.$endpoint, payload);
    }
}
